import * as AT from './actionTypes'

export type ActivateApiKeyActionType = {
  payload: { readonly id: string }
  type: typeof AT.ACTIVATE
}

export type CreateApiKeyActionType = {
  type: typeof AT.CREATE
}

export type DeactivateApiKeyActionType = {
  type: typeof AT.DEACTIVATE
}

export type GetApiKeyActionType = {
  type: typeof AT.GET_API_KEYS
}

export type ApiKeyActionType =
  | ActivateApiKeyActionType
  | CreateApiKeyActionType
  | GetApiKeyActionType
  | DeactivateApiKeyActionType

const activate = (id: string): ActivateApiKeyActionType => ({
  payload: { id },
  type: AT.ACTIVATE
})

const create = (): CreateApiKeyActionType => ({
  type: AT.CREATE
})

const deactivate = (): DeactivateApiKeyActionType => ({
  type: AT.DEACTIVATE
})

const getKeys = (): GetApiKeyActionType => ({
  type: AT.GET_API_KEYS
})

export default { activate, create, deactivate, getKeys }
